export default __webpack_public_path__ + "static/media/Wind.1e1ddf2d.svg";